import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API_ROOT } from "../service/Services";
import Spinner from "../components/Spinner";
import { FaEdit, FaTrash } from "react-icons/fa";
import * as XLSX from "xlsx";

export default function Leads() {
  const [loading, setLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [editLead, setEditLead] = useState(null);

  // Toast state
  const [toast, setToast] = useState({ message: "", visible: false });

  // Search state
  const [search, setSearch] = useState("");

  // Create new lead state
  const [newLead, setNewLead] = useState({
    date: new Date().toISOString().split("T")[0],
    typeOfLead: "Corporate Training",
    companyName: "",
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    designation: "",
    status: "Open",
    remark: "",
    reminderDate: "",
  });

  const authHeaders = useMemo(
    () => ({
      headers: { authorization: `Bearer ${localStorage.getItem("token")}` },
    }),
    []
  );

  const loadInit = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_ROOT}/leads`, authHeaders);
      setLeads(res.data?.leads || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInit();
  }, []);

  // Filtered leads for search
  const filteredLeads = leads.filter(
    (lead) =>
      lead.companyName.toLowerCase().includes(search.toLowerCase()) ||
      lead.contactName.toLowerCase().includes(search.toLowerCase()) ||
      lead.contactEmail.toLowerCase().includes(search.toLowerCase()) ||
      lead.contactPhone.toLowerCase().includes(search.toLowerCase())
  );


// Export to Excel (only 5 columns)
const exportExcel = () => {
  const dataToExport = filteredLeads.map((lead) => ({
    Name: lead.contactName,
    Company: lead.companyName,
    Designation: lead.designation,
    Email: lead.contactEmail,
    Phone: lead.contactPhone,
  }));

  const ws = XLSX.utils.json_to_sheet(dataToExport);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Leads");
  XLSX.writeFile(wb, "Leads.xlsx");
};


  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB");
  };

  return (
    <div className="flex flex-col gap-6 w-full relative">
      {loading && <Spinner />}

      {/* Toast Popup */}
      {toast.visible && (
        <div className="fixed top-5 right-5 bg-green-500 text-white px-4 py-2 rounded shadow-lg z-50 transition-all duration-300">
          {toast.message}
        </div>
      )}

      {/* Search & Export */}
      <div className="flex justify-between items-center gap-4">
        <input
          type="text"
          placeholder="Search by company, name, email or phone"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border p-2 rounded w-1/3"
        />
        <button
          onClick={exportExcel}
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
        >
          Export Excel
        </button>
      </div>

      {/* Leads Table */}
      <div className="card p-4 shadow-md rounded-lg bg-white">
        <h3 className="text-lg font-semibold mb-4">Contact Details</h3>
        <div className="overflow-x-auto">
          <div className="min-w-[1000px] overflow-y-auto max-h-[400px]">
         <table className="table-auto w-full border border-gray-200 text-sm">
  <thead className="bg-gray-100 sticky top-0 z-10">
    <tr>
      <th className="border px-2 py-1">S.No</th> {/* Serial Number */}
      <th className="border px-2 py-1">Company</th>
      <th className="border px-2 py-1">Name</th>
      <th className="border px-2 py-1">Email</th>
      <th className="border px-2 py-1">Phone</th>
      <th className="border px-2 py-1">Designation</th>
    </tr>
  </thead>
  <tbody>
    {filteredLeads.length > 0 ? (
      filteredLeads.map((lead, index) => (
        <tr key={lead._id} className="hover:bg-gray-50">
          <td className="border px-2 py-1">{index + 1}</td> {/* Serial Number */}
          <td className="border px-2 py-1">{lead.companyName}</td>
          <td className="border px-2 py-1">{lead.contactName}</td>
          <td className="border px-2 py-1">{lead.contactEmail}</td>
          <td className="border px-2 py-1">{lead.contactPhone}</td>
          <td className="border px-2 py-1">{lead.designation}</td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="6" className="text-center p-2 text-gray-500">
          No leads available
        </td>
      </tr>
    )}
  </tbody>
</table>

          </div>
        </div>
      </div>

      {/* Edit Modal */}
      {editLead && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-40">
          <div className="bg-white p-6 rounded-lg shadow-lg w-[500px] max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-semibold mb-4">Edit Lead</h3>
            {/* ... existing edit modal inputs ... */}
          </div>
        </div>
      )}
    </div>
  );
}
